import type { SelectItemData } from '.';

export const genders: SelectItemData = [
  { value: 'WOMAN', label: 'Female' },
  { value: 'MAN', label: 'Male' },
  { value: 'NON_BINARY', label: 'Non-Binary' },
  { value: 'TRANSGENDER_MAN', label: 'Transgender male' },
  { value: 'TRANSGENDER_WOMAN', label: 'Transgender female' },
  { value: 'OTHER', label: 'Other…' },
] as const;
